module.exports = __webpack_public_path__ + "img/vmp_ch_heinrich_0.5c066501.png";